import { FormattedMessage, injectIntl } from 'react-intl';
import React, {
  useState,
  useContext,
  useEffect,
  useRef,
  useCallback,
  useImperativeHandle,
} from 'react';
import { Form, Input, Checkbox, Radio, Button, Skeleton, Select, Row, Col } from 'antd';
import { Modal } from 'antd-mobile';
import classnames from 'classnames';
import { LoadingOutlined } from '@ant-design/icons';
import FloatLabel from '@/components/H5PC/Form/FloatLabel/index.js';
import Email from '@/components/H5PC/Form/Email';
import getTypeByPattern from '@/components/Common/getTypeByPattern.js';
import _ from 'lodash';
import myContext from '@/utils/createContext';
import { getUrlParams, gtag } from '@/utils/index.js';
import { paymentLcrInstallmentPayplan } from '@/components/H5PC/service/index';
const FormItem = Form.Item;
const { Option } = Select;
const key = getUrlParams('key'); // 从 URL 中获取 key

function CreditCardInstallment(props) {
  const intl = props.intl;
  const { formatMessage } = intl;

  // const installmentsRef = useRef();
  // const [hideSelect, setHideSelect] = useState(true);
  const [list, setList] = useState([]);
  // const [loading, setLoading] = useState(false);
  // const [selectItemIndex, setSelectItemIndex] = useState('');
  // const [selectItemAmount, setSelectItemAmount] = useState('');
  // const [modalVisible, setModalVisible] = useState(false);
  // radioValue 即为LCR 或者 ICR
  const { form, initData, radioValue, isMobileView } = useContext(myContext);
  const { paymentAmount, paymentCurrencySymbol } = initData;
  const h5OrWeb = isMobileView ? 'H5' : 'WEB';

  useEffect(() => {
    showModal()
    form.setFieldsValue({
      installments: '',
    });
    // setRefChange(installmentsRef);
  }, []);
  // 动态改变label的class的值
  // const setRefChange = cref => {
  //   // console.log(2222, cref.current);
  //   if (!_.isEmpty(cref.current)) {
  //     cref.current.setLabelClass();
  //   }
  // };

  // 期数选择
  // const onChooseInstallment = e => {
  //   const checked = e.target.checked;
  //   setHideSelect(!checked);
  // };

  // 期数选择
  const handleChangeNum = (e) => {
    const installmentsNum = (e.target.value);
    // setSelectItemIndex(installmentsNum);
    // setSelectItemAmount('10');
    form.setFieldsValue({ installments: installmentsNum });
  };

  // 期数埋点
  const onBlurNum = e => {
    // @todo 埋点
    gtag('支付页面', [new Date() + '期数选择']);
    gtag('支付页面', ['期数选择']);
  };
  const showModal = async () => {
    // e.preventDefault(); // 修复 Android 上点击穿透
    const amount = paymentAmount;
    // setLoading(true);
    // setModalVisible(true);
    const res = await paymentLcrInstallmentPayplan({ amount });
    // console.log(res)
    if (res && res.code === 200000) {
      setList(res.data);
    }
    // setLoading(false);
  };

  // const closeModal = (e, type) => {
  //   e.preventDefault(); // 修复 Android 上点击穿透
  //   setModalVisible(false);
  //   if (type === 'cancel') {
  //     setSelectItemIndex('');
  //     setSelectItemAmount('');
  //   }
  // };

  return (
    <>
      {radioValue === 'LCR' ? (
        <div className="h5pc-installments" style={{ display: true ? 'block' : 'none' }}>
          <Row gutter={20} className="h5pc-address-mb10">
            <Col span={24}>
              <FloatLabel
                form={form}
                name="installments"
                label={formatMessage({ id: 'ga-checkout.select-installments-title' })}
              >
                <select
                  className="my-native-select"
                  onChange={handleChangeNum}
                  onBlur={onBlurNum}
                >
                  <option style={{ display: 'none' }} value="" disabled></option>
                  {list.map(item => {
                    return (
                      item.enabled ?
                        <option value={item.installments} key={item.installments}>
                          {' '}
                          {item.installments}{' '}
                          x
                          {' '}
                          {formatMessage({ id: 'ga-checkout.select-installments-preposition' })}
                          {' '}
                          {paymentCurrencySymbol}{' '}
                          {item.amount && parseFloat(item.amount).toFixed(2)}
                          ({formatMessage({ id: 'ga-checkout.select-installments-total' })}: {paymentCurrencySymbol}{' '} {parseFloat(paymentAmount).toFixed(2)})
                        </option>
                        :
                        null
                    );
                  })}
                </select>
              </FloatLabel>
            </Col>
          </Row>
        </div>
      ) : null}

      {/* {radioValue === 'LCR' ? (
        <div className="h5pc-installments">
          <div className="h5pc-installments-one">
            <label htmlFor="chooseInstallment">
              {formatMessage({ id: 'ga-checkout.choose-installment' })}
            </label>
            <div>
              <Checkbox
                name="chooseInstallment"
                onChange={onChooseInstallment}
                id="chooseInstallment"
              ></Checkbox>
            </div>
          </div>
          <Form.Item name="installments" noStyle>
            <Input type="text" type="hidden" />
          </Form.Item>
          {!hideSelect ? (
            <>
              <div className="h5pc-installments-two" onClick={showModal}>
                <div className="h5pc-installments-two-lefter">
                  {formatMessage({
                    id: 'ga-checkout.select-installments',
                  })}
                </div>
                <div className="h5pc-installments-two-righter"></div>
              </div>

              {selectItemIndex ? (
                <div className="h5pc-installments-three">
                  <div className="h5pc-installments-three-1">
                    {formatMessage({
                      id: 'ga-checkout.installment-description',
                    })}
                    :
                  </div>
                  <div>
                    {paymentCurrencySymbol} {selectItemAmount} X{' '}
                    {selectItemIndex}{' '}
                    {formatMessage({
                      id: 'ga-checkout.number-installment',
                    })}
                  </div>
                </div>
              ) : null}
            </>
          ) : null}
        </div>
      ) : null}

      <Modal
        popup={isMobileView ? true : false}
        transparent={isMobileView ? false : true}
        animationType={isMobileView ? 'slide-up' : ''}
        visible={modalVisible}
        className={isMobileView ? '' : 'h5pc-installment'}
        afterClose={() => {}}
      >
        <div className="h5pc-installment-modal-header">
          <div className="h5pc-installment-modal-header-1">
            {formatMessage({
              id: 'ga-checkout.total-amount-installments',
            })}{' '}
            :
          </div>
          {paymentCurrencySymbol} {paymentAmount}
        </div>
        {loading ? (
          <div
            style={{
              padding: '0 15px',
              background: '#fff',
              margin: '0 15px',
            }}
          >
            <Skeleton active paragraph={{ rows: 15 }} />
          </div>
        ) : (
          <Radio.Group
            style={{ display: 'block' }}
            defaultValue={selectItemIndex}
          >
            {list.map(item => {
              return (
                <div
                  key={item.installments}
                  className="h5pc-installment-modal-content"
                >
                  <label
                    htmlFor={item.installments}
                    className="h5pc-installment-modal-content-lefter"
                  >
                    {' '}
                    {paymentCurrencySymbol}{' '}
                    {item.amount && parseFloat(item.amount).toFixed(2)} -{' '}
                    {item.installments}{' '}
                    {formatMessage({
                      id: 'ga-checkout.number-installment',
                    })}
                  </label>
                  <Radio
                    className="h5pc-installment-modal-content-righter"
                    value={item.installments}
                    id={item.installments}
                    onChange={e => handleChangeNum(e, item)}
                  ></Radio>
                </div>
              );
            })}
          </Radio.Group>
        )}
        <div className="h5pc-installment-modal-content-bottom">
          <Button
            style={{
              width: '50%',
              float: 'left',
              height: '50px',
            }}
            onClick={e => closeModal(e, 'cancel')}
          >
            {formatMessage({
              id: 'ga-checkout.cancel',
            })}
          </Button>
          <Button
            type="primary"
            style={{ width: '50%', height: '50px', border: 'none' }}
            onClick={closeModal}
          >
            {formatMessage({
              id: 'ga-checkout.confirm',
            })}
          </Button>
        </div>
      </Modal> */}
    </>
  );
}

export default injectIntl(CreditCardInstallment);
